import React, { useState } from "react";
import { number, oneOf, string } from "prop-types";

import AddNote from "../AddNote";
import EditNote from "../EditNote";

const ListingNote = props => {
  const [noteText, setNoteText] = useState(props.text);
  const isNoteUpdated = noteText !== props.text;

  return !noteText ? (
    <AddNote {...props} setNoteText={setNoteText} text={noteText} />
  ) : (
    <EditNote
      {...props}
      isNoteUpdated={isNoteUpdated}
      setNoteText={setNoteText}
      text={noteText}
    />
  );
};

ListingNote.propTypes = {
  listing_id: number.isRequired,
  listing_type: oneOf(["sale", "rental"]).isRequired,
  text: string.isRequired
};

export default ListingNote;
